module.exports = __webpack_public_path__ + "img/appsurl.f9c05b10.webp";